import type { Section } from "../contract"
import { Glance as GlanceStrip, type GlanceItem } from "../ds"
import { daysUntil } from "./blocks/Deadline"
import { RUPEES_PROMPT, compose } from "./compose"
import { rupees } from "./blocks/money"
import { firstBlock, weigh } from "./derive"
import { shortDate } from "./format"

/**
 * The glance strip (Glance README): four facts, the same numbers as sections
 * 03 to 05. Helps you, Binds against, If the demand stands, Reply by; a fact
 * the answer does not carry says so rather than disappearing.
 */
export function Glance({ sections }: { sections: Record<string, Section> }) {
  const all = Object.values(sections)
  if (!all.length) return null
  const w = weigh(sections)
  const exposure = all.map((s) => firstBlock(s, "exposure")).find(Boolean)
  const deadline = all.map((s) => firstBlock(s, "deadline")).find(Boolean)
  const total = exposure?.total?.amount_inr ?? null
  const days = deadline ? daysUntil(deadline.date) : null

  const items: GlanceItem[] = [
    {
      label: "Helps you",
      lean: "helps",
      value: String(w.helps),
      mono: true,
      sub: w.helps ? (w.helps === 1 ? "decision for your side" : "decisions for your side") : "none found",
    },
    {
      label: "Binds against",
      lean: "hurts",
      value: String(w.bindingAgainst),
      mono: true,
      sub: w.hurts > w.bindingAgainst ? `${w.hurts - w.bindingAgainst} more against, not binding` : w.hurts ? "every one against binds" : "none against",
    },
    {
      label: "If the demand stands",
      // No amount to work from: one action, which puts the rupees prompt in the composer.
      value: total === null
        ? <button type="button" className="aglance-add" onClick={() => compose(RUPEES_PROMPT)}>No amount in your question · add one</button>
        : rupees(total),
      mono: total !== null,
      sub: exposure?.monthly_interest_inr ? `+${rupees(exposure.monthly_interest_inr)} a month` : total === null ? undefined : "see 04",
    },
    {
      label: deadline?.label || "Reply by",
      value: deadline ? shortDate(deadline.date) : "No date",
      mono: !!deadline,
      sub: days === null ? "no date follows from the facts" : days >= 0 ? `${days} ${days === 1 ? "day" : "days"} left` : "passed",
    },
  ]
  return <GlanceStrip items={items} className="aglance" />
}
